module.exports = __webpack_public_path__ + "static/media/renewFriends.f47689a5.png";